/*!
 * Copyright © 2020. Verizon Connect Ireland Limited. All rights reserved.
 */

export enum ESegmentSelectionState {
  NoSelection, // default selection state
  NotSelectedOrHovered, // once a segment is selected or hovered, all other segments are in this state
  SelectedOrHovered // once a segment is selected or hovered, it is in this state
}
